/**
 * Utility class for string normalization operations
 */
export class StringNormalizer {
  /**
   * Normalizes a string by removing accents and converting to lowercase
   * for correct alphabetical sorting in Portuguese
   */
  static normalizeForSorting(str: string): string {
    if (!str) return '';
    return str
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Remove diacritics (accents)
      .trim();
  }

  /**
   * Normalizes a string for search/filter operations
   */
  static normalizeForSearch(str: string): string {
    if (!str) return '';
    return str.toLowerCase().trim();
  }
}
